import { TableColumn } from '../types/table';
import { matches } from './utils';

/**
 * Filters rows by active column and query using consistent matching logic
 * For chassis number searches (chs_no), also searches in related_cars
 */
export function filterRowsByColumn<T>(
  rows: T[],
  columns: TableColumn<T>[],
  activeKey: string,
  query: string,
): T[] {
  if (!query || !activeKey) return rows;

  const col = columns.find(c => c.key === activeKey);
  if (!col || col.searchable === false) return rows;

  return rows.filter(row => {
    const value = col.accessor ? col.accessor(row) : (row as any)[activeKey];
    const mainMatch = matches(value, query);

    // For chassis number searches, also check related_cars
    if (activeKey === 'chs_no' && !mainMatch) {
      const relatedCars = (row as any).related_cars;
      if (Array.isArray(relatedCars) && relatedCars.length > 0) {
        return relatedCars.some((rc: { chassis_number?: string }) =>
          rc.chassis_number && matches(rc.chassis_number, query)
        );
      }
    }

    return mainMatch;
  });
}




